import TagManager from 'react-gtm-module';

import config from '@config';
import type {
  ITagManagerService,
  ITrackPurchaseParams,
} from './TagManagerService';
import { TariffPlanCodeEnum } from '@constants';
import { getEnumKeyByEnumValue } from '@utils';

enum TagManagerEventsEnum {
  Purchase = 'purchase',
}

interface ITrackParams {
  event: string;
  [k: string]: any;
}

function getSubscriptionPlanNameByCode(
  tariffPlanCode: TariffPlanCodeEnum,
) {
  return getEnumKeyByEnumValue(
    TariffPlanCodeEnum,
    tariffPlanCode,
  ).toUpperCase();
}

class TagManagerService implements ITagManagerService {
  async init() {
    try {
      const debug = config.ENV !== 'production';

      if (debug) {
        return;
      }

      TagManager.initialize({ gtmId: config.GOOGLE_TAG_MANAGER_ID });
    } catch (error) {
      console.error(error);
      // Do nothing
    }
  }

  private _track({ event, ...params }: ITrackParams) {
    try {
      TagManager.dataLayer({
        dataLayer: {
          event,
          ...params,
        },
      });
    } catch (error) {
      console.error(error);
      // Do nothing
    }
  }

  trackPurchase({
    eventId,
    value,
    currency,
    code,
    transactionId,
  }: ITrackPurchaseParams) {
    const category = 'subscription';
    const name = getSubscriptionPlanNameByCode(code);

    this._track({
      event: TagManagerEventsEnum.Purchase,
      options: { eventId },
      /* eslint-disable @typescript-eslint/naming-convention */
      ecommerce: {
        value: value,
        currency: currency,
        transaction_id: transactionId,
        items: [
          {
            item_id: code,
            item_name: name,
            item_category: category,
            price: value,
          },
        ],
      },
      /* eslint-enable @typescript-eslint/naming-convention */
    });
  }
}

export default new TagManagerService();
